import React, { useEffect, useState } from 'react';
import DataTable from '../../../components/DataTable/DataTable';
import { IColInfo } from '../../../components/DataTable/Interfaces';
import Translate from '../../../components/Translate';
import { ApplicationFunctions, useAuth } from '../../../contexts/authContext';
import { useNotifications } from '../../../contexts/notificationContext';
import DataService from "../../../services/data.service";
import { IdProps } from '../../../types/IdProps';
import AddProductCategoryPopup from '../Popups/UserDefinedField_popup_AddProductCategory';


const UserDefinedField_tab_ProductCategories: React.FC<IdProps> = ({ id }) => {
    const [data, setData] = useState<[]>();
    const [showAddPopup, setShowAddPopup] = useState<boolean>(false)
    const { handleResult, handleException } = useNotifications();
    const { isAuthorizedFor } = useAuth()

    useEffect(() => {
        getTableData();
    }, [id]);

    function getTableData() {
        DataService.get<[]>('api/v1/ProductCategoryUserDefinedFields/ByUserDefinedField/' + id)
            .then(response => {
                setData(response);
            })
            .catch(e => { handleException(e); });
    }

    function deleteRow(rowData) {
        DataService.delete('api/v1/ProductCategoryUserDefinedFields/', rowData.id)
            .then(response => {
                handleResult(response);
                getTableData();
            })
            .catch(e => { handleException(e); });
    }
    let colInfos: IColInfo[] = [
        { key: true, dataProp: 'productCategoryId', visible: false },
        { title: 'Name', dataProp: 'productCategory.name' },
        { title: 'Abbr.', dataProp: 'productCategory.abbreviation' },
        { title: 'Name tree', dataProp: 'productCategory.nameTree', sort: 'asc' }
    ]
    if (isAuthorizedFor(ApplicationFunctions.EditUdf)) {
        colInfos.push(
            {
                headerButtons: [{ text: "Add", icon: 'fa-plus-square', color: '#26A69A', onClick: () => setShowAddPopup(true) }],
                rowButtons: [{ text: "Delete", icon: 'fa-trash', color: '#F3565D', onClick: deleteRow }]
            });
    }

    return (
        <>
            <p><Translate>Only items in these product-categories and all sub-categories will see the user-defined field. If no product-category is specified the user-defined field will be visible regardless the items' product-category.</Translate></p>
            <DataTable
                name='dtProductCategoriesUserDefinedFieldsForUDF'
                tableData={data}
                colInfos={colInfos}
                navigateTitle='Product category'
                navigateUrl='/plm/ItemSetup/ProductCategory/'
            />
            {showAddPopup && <AddProductCategoryPopup show={showAddPopup} onHide={() => { setShowAddPopup(false); getTableData(); }} userDefinedFieldId={id} />}
        </>
    )
}
export default UserDefinedField_tab_ProductCategories;
